/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

 function findGetParameter(parameterName) {
     var result = null,
         tmp = [];
     location.search
         .substr(1)
         .split("&")
         .forEach(function (item) {
           tmp = item.split("=");
           if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
         });
     return result;
 }

app.controller('ValidationController', ['$rootScope', '$scope', '$http', 'NetworkService', 'MainService', 'Notification','$timeout', function ($rootScope, $scope, $http, NetworkService, MainService, Notification, $timeout) {

    $scope.cameraRequested = true;
      $scope.start = function() {
         $scope.cameraRequested = true;
     }

     $scope.location = findGetParameter("location");

      $timeout(function(){
        $scope.setPassport("lukas.kaeferle@chello.at");
      },1000)

       $scope.processURLfromQR = function (email) {
         //$scope.url = url;
         $scope.cameraRequested = false;
         $scope.setPassport(email);
         //alert(url)
      }

      $scope.onError = function(err)
      {
        //alert(err)
      }

      $scope.setPassport = function(email)
      {
        NetworkService.getPassportDetails(email, $scope.location, function (data) {
          $scope.passData = data.details
          $scope.hasAccess = data.hasAccess
        })
      }

        $scope.render = function()
        {

        }

        $scope.init = function ()
        {
          $scope.render()
        }

        $scope.init()
    }])
